import React, { useState } from 'react';
import Carat from "./Carat"

const Jel = ({keywords, fireAmplitude}) => {
  const [showKeywords, setShowKeywords] = useState(false)

  const renderKeywords = () => {
    return keywords.map( (word, idx) => {
      let query = word.split(" ").join("+")
      return (
        <React.Fragment key={idx}>
          <a className="keyword" target="_blank" rel="noopener">{word}</a>
          {idx < keywords.length - 1 && <span key={`${idx}-span`}>, </span>}
        </React.Fragment>
      )

    })
  }

  return (
    <div className="left-sidebar-row">
      <div className="collapsible" onClick={() => {setShowKeywords(!showKeywords)}}>
        <h2>JEL Classifications</h2>
        {<Carat showNav={showKeywords} setShowNav={setShowKeywords}/>}
      </div>

      <ul className='keywords no-margin'>
        {showKeywords && renderKeywords()}
      </ul>
    </div>
  )
}

export default Jel